import { shallowEqual, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'store/configureStore';
import {
  selectConversationInputText,
  selectConversationSummary,
  selectConversationSummaryDraft,
  selectReplyingToMessage,
} from 'store/conversations/selectors';
import { useConversationMetadata } from './useConversations';

export default function useSelectConversations() {
  const conversationId = useParams().conversationId as string;
  const historicConversationId = useParams().historicConversation as string;

  // The conversation row itself comes from the TanStack `['conversations']` cache (the
  // single source of truth for the list); the rest of the pieces (drafts, summaries,
  // open messages, reply-target) still live in Redux.
  const conversationMetadata = useConversationMetadata(conversationId);

  const conversationSummary = useSelector(
    (state: RootState) => selectConversationSummary(state, conversationId),
    shallowEqual,
  );
  const conversationSummaryDraft = useSelector(
    (state: RootState) => selectConversationSummaryDraft(state, conversationId),
    shallowEqual,
  );
  const inputText = useSelector((state: RootState) => selectConversationInputText(state, conversationId));

  const historicConversationSummary = useSelector(
    (state: RootState) => selectConversationSummary(state, historicConversationId),
    shallowEqual,
  );

  const historicConversationSummaryDraft = useSelector(
    (state: RootState) => selectConversationSummaryDraft(state, historicConversationId),
    shallowEqual,
  );

  const conversationInputText = useSelector(
    (state: RootState) => selectConversationInputText(state, conversationId),
    shallowEqual,
  );

  const replyingToMessage = useSelector(
    (state: RootState) => selectReplyingToMessage(state, conversationId),
    shallowEqual,
  );

  return {
    conversationId,
    conversationMetadata,
    conversationSummary,
    conversationSummaryDraft,
    inputText,
    historicConversationSummary,
    historicConversationSummaryDraft,
    conversationInputText,
    replyingToMessage,
  };
}
